import i18n from '../i18n'

export enum PUBLIC_TRANSPORT_TYPE {
  BUS = 'BUS',
  TRAIN = 'TRAIN',
  TRAM = 'TRAM',
  TROLLEY = 'TROLLEY',
  AIRPORT = 'AIRPORT',
  HARBOR = 'HARBOR',
}

export const getAccessOptionLabel = (key: string) => {
  return {
    is_signposted: i18n.global.t('access.isSignPosted'),
    is_hard_surfaced_road: i18n.global.t('access.isHardSurfacedRoad'),
    access_by_tour_bus: i18n.global.t('access.byTourBus'),
    access_by_public_transport: i18n.global.t('access.byPublicTransport'),
    access_by_car: i18n.global.t('access.byCar'),
    access_on_foot: i18n.global.t('access.onFoot'),
  }[key]
}

export const getPublicTransportTypeLabel = (
  key: PUBLIC_TRANSPORT_TYPE,
): string => {
  return (
    {
      [PUBLIC_TRANSPORT_TYPE.BUS]: i18n.global.t('publicTransport.bus'),
      [PUBLIC_TRANSPORT_TYPE.TRAIN]: i18n.global.t('publicTransport.train'),
      [PUBLIC_TRANSPORT_TYPE.TRAM]: i18n.global.t('publicTransport.tram'),
      [PUBLIC_TRANSPORT_TYPE.TROLLEY]: i18n.global.t('publicTransport.trolley'),
      [PUBLIC_TRANSPORT_TYPE.AIRPORT]: i18n.global.t('publicTransport.airport'),
      [PUBLIC_TRANSPORT_TYPE.HARBOR]: i18n.global.t('publicTransport.harbor'),
    }[key] ?? key
  )
}

export const getDistanceInputValue = (key: string) => {
  return {
    access_by_tour_bus: 'tour_bus_distance',
  }[key]
}
